export default "__VITE_ASSET__BGrIptwK__"